import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import CircularProgress from '@material-ui/core/CircularProgress';
import { showMessage } from '../../utils/helper';
function ImageDownloader({ s3Url, iconColor }) {
    const [isDownloading, setIsDownloading] = useState(false);
    const [downloadError, setDownloadError] = useState(null);

    const handleDownload = async () => {
        setIsDownloading(true);
        setDownloadError(null); // Clear any previous errors

        try {
            // Attempt direct download first
            const timestamp = new Date().getTime();
            const urlWithTimestamp = `${s3Url}?timestamp=${timestamp}`;

            const response = await fetch(urlWithTimestamp, {
                mode: 'cors',
                cache: 'no-store',
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();
            const filename = s3Url.split('/').pop().split('?')[0]; // Clean filename

            // Create download link
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Cleanup
            link.addEventListener('click', () => {
                setTimeout(() => URL.revokeObjectURL(link.href), 1000);
            });
        } catch (error) {
            console.error('Download error:', error);

            // If download fails, try to open the image in a new tab
            try {
                // Check if the URL is an image (common extensions)
                const imageExtensions = [
                    '.jpg',
                    '.jpeg',
                    '.png',
                    '.gif',
                    '.webp',
                    '.svg',
                ];
                const isImage = imageExtensions?.some((ext) =>
                    s3Url.toLowerCase().includes(ext),
                );

                if (isImage) {
                    // Open image in new tab
                    window.open(s3Url, '_blank', 'noopener,noreferrer');
                } else {
                    // For non-images, still try to open but it might be blocked by browser
                    const newWindow = window.open(
                        s3Url,
                        '_blank',
                        'noopener,noreferrer',
                    );
                    if (
                        !newWindow ||
                        newWindow.closed ||
                        typeof newWindow.closed === 'undefined'
                    ) {
                        throw new Error('Popup was blocked by browser');
                    }
                }
            } catch (fallbackError) {
                const errorMsg =
                    fallbackError?.message || 'Failed to download file';
                showMessage(errorMsg, 'error');
                setDownloadError(errorMsg);
            }
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <div
            style={{
                width: '48px',
                height: '48px',
            }}
        >
            {!!isDownloading ? (
                <CircularProgress />
            ) : (
                <IconButton
                    onClick={handleDownload}
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                >
                    <GetAppIcon
                        style={{
                            color: !!iconColor ? iconColor : 'inherit',
                        }}
                    />
                </IconButton>
            )}
        </div>
    );
}
export default ImageDownloader;
